<div class="appliance-details-stepped-content-toggle__container">
  <p class="mb-4 mt-4">
    {{ textBefore }}
    <button
      (click)="contentToggle()"
      class="link appliance-details-stepped-content-toggle__button"
      type="button"
    >
      {{ toggleLabel }}
    </button>
  </p>

  <ng-container *ngIf="displayContent">
    <ng-content></ng-content>
  </ng-container>
</div>
